import * as Fields from "#root/components/form/fields";
import StandardEditor from "#root/components/standard-editor";
import { createProviderArticleCollection } from "#root/schema/platform/newsrpm-tracking";
import type { ReactNode } from "react";
import { useMemo } from "react";
import PageLayout from "./layout";

export default function ({ providerCode, slug }): ReactNode {
  const articleCollection = useMemo(() => createProviderArticleCollection(providerCode), [providerCode]);

  return (
    <PageLayout title="NewsRPM - Manage Article">
      <section>
        <h1>Edit Article</h1>
        <p>Update the article's visibility, headline, summary, and other metadata. Changes will be reflected across all syndication partners.</p>
        <StandardEditor id={slug} collection={articleCollection}>
          <Fields.Set name="visiblity">
            <label>Visibility</label>
            <Fields.Select>
              <Fields.Option value="published">Published</Fields.Option>
              <Fields.Option value="retracted">Retracted</Fields.Option>
            </Fields.Select>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="headline">
            <label>Headline</label>
            <Fields.String/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="summary">
            <label>Summary</label>
            <Fields.TextArea rows={5}/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="firstParagraph">
            <label>First Paragraph</label>
            <Fields.TextArea rows={5}/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="link">
            <label>Link</label>
            <Fields.WebsiteURI/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="createdAt">
            <label>Creation Time</label>
            <Fields.Timestamp/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="updatedAt">
            <label>Update Time</label>
            <Fields.Timestamp/>
            <Fields.Validity/>
          </Fields.Set>
        </StandardEditor>
      </section>
    </PageLayout>
  );
}
